import React from "react";
import SEOLandingPage from "../../../components/tools/SEOLandingPage";

const AIFlashcardGenerator: React.FC = () => {
  return (
    <SEOLandingPage
      // SEO
      title="AI Flashcard Generator - Create Study Cards Instantly | YouWo AI"
      metaDescription="Generate flashcards automatically with AI. Upload PDFs, paste notes, or record lectures - get study-ready flashcards in seconds. Free AI flashcard generator."
      keywords="ai flashcard generator, automatic flashcard maker, flashcard creator ai, generate flashcards from pdf, flashcards from notes, smart flashcards"
      canonicalUrl="https://youwo.ai/tools/ai-flashcard-generator"
      // Hero
      headline="AI Flashcard Generator: Study Cards in Seconds"
      subheadline="Stop spending hours creating flashcards. Our AI analyzes your content and generates effective question-answer pairs automatically."
      heroIcon="lucide:wand-2"
      heroIconColor="text-pink-500"
      heroIconBg="bg-pink-50"
      // Problem/Solution
      problemTitle="Manual Flashcard Creation Wastes Time"
      problemDescription="For every hour of lecture, you might spend another hour creating flashcards. That's time you could spend actually studying and learning the material."
      solutionTitle="Let AI Do the Heavy Lifting"
      solutionDescription="Simply upload a PDF, paste your notes, or record a lecture. Our AI identifies key concepts, definitions, and facts - then creates flashcards you can start studying immediately."
      // Features
      features={[
        {
          icon: "lucide:brain",
          title: "Active Recall Learning",
          description: "Flashcards use active recall - the most effective learning technique proven by science.",
        },
        {
          icon: "lucide:globe",
          title: "100+ Languages",
          description: "Generate flashcards from content in over 100 languages.",
        },
        {
          icon: "lucide:file-text",
          title: "PDF to Flashcards",
          description: "Upload any PDF textbook or notes and get flashcards generated automatically.",
        },
        {
          icon: "lucide:youtube",
          title: "Video to Flashcards",
          description: "Turn YouTube lectures into study flashcards with timestamps.",
        },
        {
          icon: "lucide:sliders",
          title: "Difficulty Control",
          description: "Generate easy, medium, or hard flashcards based on your needs.",
        },
        {
          icon: "lucide:share-2",
          title: "Export with Pro",
          description: "Export to Anki, Quizlet, or other apps with YouWo AI Pro.",
        },
      ]}
      // CTA
      ctaText="Generate Flashcards Free"
      ctaLink="https://apps.apple.com/app/youwo-ai-agent/id6760689478"
      // Related
      relatedTools={[
        { name: "AI Flashcard Maker", href: "/tools/flashcard-maker", icon: "lucide:layers" },
        { name: "Quizlet Alternative", href: "/tools/quizlet-alternative", icon: "lucide:book-open" },
        { name: "Anki Alternative", href: "/tools/anki-alternative", icon: "lucide:repeat" },
        { name: "PDF Summarizer", href: "/tools/pdf-summarizer", icon: "lucide:file-text" },
        { name: "PDF to Study Guide", href: "/tools/pdf-to-study-guide", icon: "lucide:book-open-check" },
      ]}
    />
  );
};

export default AIFlashcardGenerator;
